import React, { useState } from 'react';
import DashboardSidebar from './DashboardSidebar';
import DashboardTopBar from './DashboardTopBar';

const DashboardLayout = ({ children, activeTab, setTab, userData, matchResult }) => {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  const handleOpenMobileNav = () => setIsMobileNavOpen(true);
  const handleCloseMobileNav = () => setIsMobileNavOpen(false);

  // Close mobile nav when clicking outside or on desktop
  React.useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIsMobileNavOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="flex h-screen overflow-hidden bg-slate-50">
      <DashboardSidebar
        isMobileOpen={isMobileNavOpen}
        onCloseMobile={handleCloseMobileNav}
        activeTab={activeTab}
        setTab={setTab}
      />

      <div className="flex flex-col flex-1 relative overflow-hidden">
        <DashboardTopBar
          onOpenMobileNav={handleOpenMobileNav}
          userData={userData}
          matchResult={matchResult}
        />
        <main className="flex-1 overflow-y-auto p-4 md:p-6 lg:p-8">
          {children}
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;


